import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import { Controller, useFormContext } from "react-hook-form";

import InputField from "../../../shared/components/input-field/InputField";
import ReactSelect from "../../../shared/components/ReactSelect/ReactSelect";
import CustomError from "../../../shared/components/custom-error/CustomError";

const CompanyInformationForm = (props) => {
  const { allCountries, selectedCountry, setSelectedCountry } = props;

  const {
    formState: { errors },
    watch,
    setValue,
    setError,
    clearErrors,
  } = useFormContext();
  const [phoneLength, setPhoneLength] = useState(0);

  useEffect(() => {
    if (watch("company.phoneNumber")) {
      if (
        phoneLength > watch("company.phoneNumber")?.length &&
        watch("company.phoneNumber")?.length < 15
      ) {
        setError("company.phoneNumber", {
          type: "minLength",
          message: "Invalid phone number",
        });
      } else {
        clearErrors("company.phoneNumber");
      }
    }

    // eslint-disable-next-line
  }, [watch("company.phoneNumber")]);

  return (
    <div className="company-information">
      <div className="row">
        <div className="col-12 company-information-heading">
          Company Information
        </div>
        {/* company/agency name input field */}
        <div className="col-12 col-lg-6 pe-xl-4">
          <div className="input-field-wrapper">
            <InputField name="company.name" placeHolder="Company/Agency Name" />
            <CustomError errorMessage={errors.company?.name?.message} />
          </div>
        </div>
        {/* phone number input field */}
        <div className="col-12 col-lg-6 ps-xl-4">
          <div className="input-field-wrapper">
            <Controller
              name="company.phoneNumber"
              placeHolder="(916) 687-9606"
              rules={{ required: true }}
              render={({ field: { ref, ...field } }) => (
                <PhoneInput
                  placeholder="(916) 687-9606"
                  {...field}
                  inputExtraProps={{
                    ref,
                    required: true,
                    autoFocus: true,
                  }}
                  onChange={(phone, country) => {
                    setValue("company.phoneNumber", phone);
                    setPhoneLength(
                      country.format.split("").filter((char) => char === ".")
                        .length
                    );
                  }}
                  country={"us"} // Default country code
                  masks={{ sa: '.. ... ....' }}
                />
              )}
            />
            <CustomError errorMessage={errors.company?.phoneNumber?.message} />
          </div>
        </div>
        {/* license number input field */}
        <div className="col-12 col-lg-6 pe-xl-4">
          <div className="input-field-wrapper">
            <InputField
              name="company.licenseNumber"
              placeHolder="Licence Number"
            />
            <CustomError
              errorMessage={errors.company?.licenseNumber?.message}
            />
          </div>
        </div>
        {/* website url input field */}
        <div className="col-12 col-lg-6 ps-xl-4">
          <div className="input-field-wrapper">
            <InputField
              type="url"
              name="company.websiteUrl"
              placeHolder="Website URL"
            />
            <CustomError errorMessage={errors.company?.websiteUrl?.message} />
          </div>
        </div>
        {/* address line 1 input field*/}
        <div className="col-12">
          <div className="input-field-wrapper">
            <InputField
              type="text"
              name="company.addressLine1"
              placeHolder="Office Address Line 1"
            />
            <CustomError errorMessage={errors.company?.addressLine1?.message} />
          </div>
        </div>
        {/* address line 2 input field */}
        <div className="col-12">
          <div className="input-field-wrapper">
            <InputField
              type="text"
              name="company.addressLine2"
              placeHolder="Office Address Line 2"
            />
            <CustomError errorMessage={errors.company?.addressLine2?.message} />
          </div>
        </div>
        {/* country dropdown */}
        <div className="col-12 col-lg-4">
          <div className="input-field-wrapper">
            <ReactSelect
              options={allCountries}
              name="countryId"
              placeholder="Select Country"
              selectedOption={selectedCountry}
              setSelectedOption={setSelectedCountry}
            />
            <CustomError errorMessage={errors.company?.countryId?.message} />
          </div>
        </div>
        {/* state/province dropdown */}
        <div className="col-12 col-lg-4">
          <div className="input-field-wrapper">
            <InputField
              name="company.stateAndProvince"
              placeHolder="State/Province"
              className="input-field-height"
            />
            <CustomError
              errorMessage={errors.company?.stateAndProvince?.message}
            />
          </div>
        </div>
        {/* city dropdown */}
        <div className="col-12 col-lg-4">
          <div className="input-field-wrapper">
            <InputField
              name="company.city"
              placeHolder="City"
              className="input-field-height"
            />
            <CustomError errorMessage={errors.company?.city?.message} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyInformationForm;
